module.exports = __webpack_public_path__ + "static/media/plan-wom-400gb-wom64.905fa9af.svg";